import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
const Footer = () => {
  return (
    <>
      <div className="Footer">
        <span className="footer-copy">© 2024–2026 We Win Together</span>
        <span className="footer-links">
          <Link
            to="https://www.facebook.com/wewintogethergroup/"
            target="_blank"
            rel="noreferrer"
          >
            Facebook
          </Link>
          <Link to="https://x.com/WeWin_Together" target="_blank" rel="noreferrer">
            X
          </Link>
        </span>
      </div>
    </>
  );
};

export default Footer;
